import React from "react";
import {
  TouchableOpacity,
  View,
  StyleSheet
} from "react-native";

import ImageLoad from "./ImageLoad";
import StyledText from "./StyledText";
import StyledIcon from "./StyledIcon";

import Style from "ae-style";

import { useResources } from "@aetonix/hooks";

const styles = StyleSheet.create({
	image: {
		height: 128,
		width: 128,
		borderRadius: 12
	},
	fileButton: {
		margin: Style.layout.marginSlim,
		alignItems: "stretch",
	},
	fileContainer: {
		borderRadius: 12,
		alignItems: "center",
		justifyContent: "center",
		height: 128,
		width: 128,
		borderWidth: 1,
		borderColor: Style.colors.secondary
	}
});

export default function FileItem(props) {
	const { dispatch, localize } = useResources();

	const clickToEnlarge = localize("fileviewer.enlarge");

	const file = props.file;
	const id = props.id;
	const url = file.url || file.uri;
	const format = file.format;
	if (!file || !url || !format) return null;

	let name = (url.split("-").slice(-1)[0]) || "";
	const extension = name.split(".").slice(-1) || "";

	if(name.length > 9)
		name = name.slice(0, 9) + "[...]." + extension;

	let openExternal;
	if (dispatch) {
		openExternal = dispatch("fileviewer:trigger:view", {
			file: file
		});
	} else {
		openExternal = null;
	}

	const source = {
		uri: url
	};

	let icon = "file";
	if(format.indexOf("video") !== -1)
		icon = "video";
	else if(format.indexOf("image") !== -1)
		icon = "image";
	else if(format.indexOf("pdf") !== -1)
		icon = "file-pdf-o";
	else if(format.indexOf("audio") !== -1)
		icon = "file-audio-o";

	let renderFile = (
		<FileIcon icon={icon} />
	);

	if(format.indexOf("image") !== -1)
		renderFile = (
			<ImageLoad style={styles.image} resizeMethod="resize" resizeMode="cover" source={source} />
		);

	return (
		<TouchableOpacity testID={id} style={styles.fileButton} onPress={openExternal}>
			{renderFile}
			<StyledText red small>{clickToEnlarge}</StyledText>
		</TouchableOpacity>
	);
}

function FileIcon(props){
	const icon = props.icon;
	const iconSize = "hugeHeading";

	return (
		<View style={styles.fileContainer}>
			<StyledIcon size={iconSize} name={icon} />
		</View>
	);
}